import { Form, formStatus, createForm, FormConfig } from "../../records/Form";
import * as actionTypes from "./actionTypes";
import { Actions } from "./types";
import produce, { castDraft, Draft } from "immer";
import { compare, applyPatch } from "fast-json-patch";

export interface FormState {
	[k: string]: Form;
}

const forms = (state: Readonly<FormState> = {}, action: Actions): FormState => {
	return produce(state, draft => {
		switch (action.type) {
			case actionTypes.FORM_NEW: {
				draft[action.fid] = castDraft(createForm(action.data));
				break;
			}

			case actionTypes.FORM_MERGE_UPDATE: {
				mergeFormChanges(draft, action.fid, action.update);
				break;
			}

			case actionTypes.FORM_STATUS_UPDATE: {
				draft[action.fid]._ui.status = action.status;
				if (action.message)
					draft[action.fid]._ui.message = action.message;
				break;
			}

			case actionTypes.FORM_REMOVE: {
				delete draft[action.fid];
				break;
			}

			case actionTypes.JSON_PATCH: {
				action.patch.forEach(p => {
					draft[action.fid]._ui.patches.push(p);
				});
				break;
			}

			case actionTypes.SEND_PATCHES: {
				draft[action.fid]._ui.status = formStatus.updating;
				break;
			}

			case actionTypes.JSON_PATCH_SUCCESS: {
				mergeFormChanges(draft, action.fid, action.update);
				const patches = draft[action.fid]._ui.patches;
				draft[action.fid]._ui.patches = patches.slice(
					action.clearPatches,
					patches.length
				);
				break;
			}

			case actionTypes.FORM_SET_MESSAGE: {
				draft[action.fid]._ui.message = action.message;
				break;
			}

			case actionTypes.FORM_CLEAR_MESSAGE: {
				delete draft[action.fid]._ui.message;
				break;
			}

			default: {
				return draft;
			}
		}
	});
};

function mergeFormChanges(
	draft: Draft<FormState>,
	fid: string,
	update: FormConfig
) {
	const diff = compare(draft[fid].server, update);
	applyPatch(draft[fid].server, diff);
}

export default forms;
